import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SolicitationForm from './components/SolicitationForm';
import ProjectForm from './components/ProjectForm';
import ProjectReport from './components/ProjectReport';
import ProjectHistory from './components/ProjectHistory';
import HomePage from './components/HomePage';
import LoginPage from './components/LoginPage';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userName, setUserName] = useState('');

  useEffect(() => {
    // Verificar se há token válido no localStorage
    const token = localStorage.getItem('authToken');
    const storedUserName = localStorage.getItem('userName');
    
    if (token) {
      setIsAuthenticated(true);
      setUserName(storedUserName || 'Usuário');
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (token) => {
    const storedUserName = localStorage.getItem('userName');
    setUserName(storedUserName || 'Usuário');
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('userName');
    setIsAuthenticated(false);
    setUserName('');
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* CSS ULTRA ESPECÍFICO para forçar toasts */}
      <style>{`
        /* CSS com máxima especificidade */
        body .Toastify__toast-container {
          position: fixed !important;
          top: 20px !important;
          right: 20px !important;
          z-index: 999999 !important;
          pointer-events: auto !important;
        }
        
        body .Toastify__toast-container--top-right {
          position: fixed !important;
          top: 20px !important;
          right: 20px !important;
          z-index: 999999 !important;
        }
        
        body .Toastify__toast {
          z-index: 999999 !important;
          margin-bottom: 10px !important;
          position: relative !important;
        }
        
        /* Forçar overflow visible em todas as divs que podem interferir */
        .min-h-screen {
          overflow: visible !important;
        }
        
        .overflow-hidden {
          overflow: visible !important;
        }
        
        /* Garantir que nenhuma div interfira */
        body {
          overflow-x: hidden;
        }
      `}</style>
      
      <Router>
        <div className="min-h-screen bg-gray-50 relative">
          {isAuthenticated ? (
            <Routes>
              <Route path="/" element={<HomePage userName={userName} onLogout={handleLogout} />} />
              <Route path="/recursos" element={<SolicitationForm userName={userName} onLogout={handleLogout} />} />
              <Route path="/projetos" element={<ProjectForm userName={userName} onLogout={handleLogout} />} />
              <Route path="/projetos/:identificador" element={<ProjectReport userName={userName} onLogout={handleLogout} />} />
              <Route path="/solicitacoes" element={<ProjectHistory userName={userName} onLogout={handleLogout} />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          ) : (
            <LoginPage onLogin={handleLogin} />
          )}
        </div>
      </Router>
      
      {/* ToastContainer FORA da div principal com configuração específica */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        enableMultiContainer={false}
        limit={5}
        style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 999999,
          fontSize: '14px',
          width: 'auto',
          maxWidth: '400px'
        }}
        toastStyle={{
          position: 'relative',
          zIndex: 999999,
          marginBottom: '10px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
        }}
      />
    </>
  );
}

export default App;
